module.exports = __webpack_public_path__ + "static/graph2desktop-89b2cbbdd2b976a5766e1827655050a7.png";